// src/pages/BankTransferPage.jsx
import { Link } from "react-router-dom";

export default function BankTransferPage({ lang }) {
  return (
    <section
      className="section"
      style={{
        maxWidth: "650px",
        margin: "0 auto",
        padding: "30px 20px",
        background: "white",
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
      }}
    >
      <h2
        style={{
          fontSize: "28px",
          marginBottom: "10px",
          textAlign: "center",
          fontWeight: 700,
        }}
      >
        {lang === "pl"
          ? "Dziękujemy za zamówienie"
          : "Thank you for your order"}
      </h2>

      <p
        style={{
          textAlign: "center",
          color: "#666",
          marginBottom: "25px",
          lineHeight: 1.5,
          fontSize: "16px",
        }}
      >
        {lang === "pl"
          ? "Poniżej znajdziesz dane do wykonania tradycyjnego przelewu."
          : "Below you will find the details for making a bank transfer."}
      </p>

      <div
        style={{
          background: "#fafafa",
          border: "1px solid #eee",
          borderRadius: "10px",
          padding: "20px",
          marginBottom: "25px",
        }}
      >
        <h3 style={{ marginBottom: "15px", fontSize: "20px" }}>
          {lang === "pl" ? "Dane do przelewu" : "Bank transfer details"}
        </h3>

        {/* FULL DATA BLOCK */}
        <div style={{ lineHeight: 1.7, fontSize: "16px" }}>
          <strong>{lang === "pl" ? "Odbiorca:" : "Recipient:"}</strong>
          <br />
          Art Rafał Tołczyk
          <br />
          ul. Boya-Żeleńskiego 2
          <br />
          15-198 Białystok
          <br />
          NIP: 9661263250
          <br />

          <div style={{ height: "16px" }} />

          <strong>{lang === "pl" ? "Numer konta:" : "Bank account:"}</strong>
          <br />
          <span
            style={{
              fontSize: "18px",
              fontWeight: 600,
              letterSpacing: "1px",
            }}
          >
            38 1140 2004 0000 3202 8173 2686
          </span>

          <div style={{ height: "16px" }} />

          <strong>{lang === "pl" ? "Tytuł przelewu:" : "Transfer title:"}</strong>
          <br />
          {lang === "pl"
            ? "Zakup obrazu tekstylnego — sklep online"
            : "Purchase of textile artwork — online store"}
          <br />

          <div style={{ height: "16px" }} />

          <strong>{lang === "pl" ? "Kwota:" : "Amount:"}</strong>
          <br />
          {lang === "pl"
            ? "Zgodnie z potwierdzeniem zamówienia."
            : "As shown in the order confirmation."}
        </div>
      </div>

      <p style={{ textAlign: "center", marginBottom: "30px", color: "#666" }}>
        {lang === "pl"
          ? "Po zaksięgowaniu płatności natychmiast potwierdzimy realizację zamówienia."
          : "Once the payment is received, we will confirm your order immediately."}
      </p>

      <div style={{ textAlign: "center" }}>
        <Link to="/" style={{ textDecoration: "none" }}>
          <button
            className="btn-primary"
            style={{
              padding: "12px 30px",
              borderRadius: "999px",
              fontSize: "16px",
              fontWeight: 600,
            }}
          >
            {lang === "pl" ? "Powrót do strony głównej" : "Return home"}
          </button>
        </Link>
      </div>
    </section>
  );
}
